import * as Lambda from './LambdaApi';

const getArchivedRequests = async (residentIds, pageNo, limit, requestType = 'all') => {
    interface Params {
        queryStringParameters: {
            [key: string]: string | undefined | boolean;
        };
    }
    const apiPath = `/requests`;
    const params: Params = {
        queryStringParameters: { limit, pageNo, archived: true, requestType },
    };
    if (residentIds.length) {
        params.queryStringParameters.residentIds = residentIds.join(',');
    }

    try {
        const residentRequests = await Lambda.Get(apiPath, params, 'lambda');
        return residentRequests;
    } catch (err) {
        console.error(err);
        return false;
    }
};

const respondToGreeting = async (requestId) => {
    const apiPath = `/requests/${requestId}/respond`;
    try {
        const requestAccept = await Lambda.Post(apiPath, {}, 'lambda');
        console.log(requestAccept, 'requestAccept');
        return requestAccept;
    } catch (err) {
        console.error(err);

        return Promise.reject('Something went wrong');
    }
};

const getArchivedActivities = async (residentIds, pageNo, limit) => {
    interface Params {
        queryStringParameters: {
            [key: string]: string | undefined | boolean;
        };
    }
    const apiPath = `/activities`;
    const params: Params = { queryStringParameters: { limit, pageNo, archived: true } };
    if (residentIds.length) {
        params.queryStringParameters.residentIds = residentIds.join(',');
    }

    try {
        const relativeActivityData = await Lambda.Get(apiPath, params, 'lambda');
        return relativeActivityData;
    } catch (error) {
        console.error(error);
        return false;
    }
};

const getActivities = async (residentIds, pageNo, limit) => {
    interface Params {
        queryStringParameters: {
            [key: string]: string | undefined;
        };
    }
    const apiPath = `/activities`;
    const params: Params = { queryStringParameters: { limit, pageNo } };
    if (residentIds.length) {
        params.queryStringParameters.residentIds = residentIds.join(',');
    }

    try {
        const relativeActivityData = await Lambda.Get(apiPath, params, 'lambda');
        return relativeActivityData;
    } catch (error) {
        console.error(error);
        return false;
    }
};

const unAcceptRequest = async (requestId) => {
    const apiPath = `/requests/${requestId}/accept`;
    try {
        const result = await Lambda.Delete(apiPath, {}, 'lambda');
        console.log(result, ': result');
        return result;
    } catch (err) {
        console.error(err);
        if (err.response.status === 409) {
            return Promise.reject(err.response.data.message);
        } else {
            return Promise.reject('Something went wrong');
        }
    }
};

const acceptRequest = async (requestId) => {
    const apiPath = `/requests/${requestId}/accept`;
    try {
        const requestAccept = await Lambda.Post(apiPath, {}, 'lambda');
        console.log(requestAccept, 'requestAccept');
        return requestAccept;
    } catch (err) {
        console.error(err);

        if (err.response.status === 409) {
            return Promise.reject(err.response.data.message);
        } else {
            return Promise.reject('Something went wrong');
        }
    }
};

const getAcceptedRequests = async (residentIds) => {
    interface Params {
        queryStringParameters: {
            [key: string]: string | undefined;
        };
    }
    const apiPath = `/me/requests`;
    try {
        const params: Params = { queryStringParameters: {} };
        if (residentIds.length) {
            params.queryStringParameters.residentIds = residentIds.join(',');
        }
        const acceptedRequests = await Lambda.Get(apiPath, params, 'lambda');
        console.log('acceptedRequests: ', acceptedRequests);
        return acceptedRequests;
    } catch (err) {
        console.error(err, 'err');
        return false;
    }
};

const closeRequest = async (requestId) => {
    const apiPath = `/requests/${requestId}/close`;
    try {
        const requestAccept = await Lambda.Post(apiPath, {}, 'lambda');
        console.log(requestAccept, 'requestAccept');
        return requestAccept;
    } catch (err) {
        console.error(err);

        if (err.response.status === 409) {
            return Promise.reject(err.response.data.message);
        } else {
            return Promise.reject('Something went wrong');
        }
    }
};

const getRequests = async (residentIds, pageNo, limit, requestType = 'all') => {
    interface Params {
        queryStringParameters: {
            [key: string]: string | undefined;
        };
    }
    const apiPath = `/requests`;
    const params: Params = {
        queryStringParameters: { limit, pageNo, requestType },
    };
    if (residentIds.length) {
        params.queryStringParameters.residentIds = residentIds.join(',');
    }

    try {
        const residentRequests = await Lambda.Get(apiPath, params, 'lambda');
        return residentRequests;
    } catch (err) {
        console.error(err);
        return false;
    }
};

const getRequest = async (requestId) => {
    const apiPath = `/requests/${requestId}`;
    try {
        const request = await Lambda.Get(apiPath, {}, 'lambda');
        return request;
    } catch (err) {
        console.error(err);
        return false;
    }
};

const getActivity = async (activityId) => {
    const apiPath = `/activities/${activityId}`;
    try {
        const request = await Lambda.Get(apiPath, {}, 'lambda');
        return request;
    } catch (err) {
        console.error(err);
        return false;
    }
};

const toggleRequestArchivedStatus = async (requestId, isArchived = true) => {
    const apiPath = `/requests/${requestId}/archive`;
    try {
        let result;
        if (isArchived) {
            result = await Lambda.Post(apiPath, {}, 'lambda');
        } else {
            result = await Lambda.Delete(apiPath, {}, 'lambda');
        }
        console.log(result, ': result');
        return result;
    } catch (err) {
        console.error(err);
        if (err.response.status === 409) {
            return Promise.reject(err.response.data.message);
        } else {
            return Promise.reject('Something went wrong');
        }
    }
};

const toggleActivityArchivedStatus = async (activityId, isArchived = true) => {
    const apiPath = `/activities/${activityId}/archive`;
    try {
        let result;
        if (isArchived) {
            result = await Lambda.Post(apiPath, {}, 'lambda');
        } else {
            result = await Lambda.Delete(apiPath, {}, 'lambda');
        }
        console.log(result, ': result');
        return result;
    } catch (err) {
        console.error(err);
        if (err.response.status === 409) {
            return Promise.reject(err.response.data.message);
        } else {
            return Promise.reject('Something went wrong');
        }
    }
};

const convertGreetingToRequest = async (greetingId) => {
    const apiPath = `/requests`;
    try {
        const request = await Lambda.Post(apiPath, { type: 'fromGreetings', greetingId }, 'lambda');
        return request;
    } catch (err) {
        console.error(err);
        return false;
    }
};
const convertGreetingToActivity = async (greetingId) => {
    const apiPath = `/activities`;
    console.log(greetingId);
    try {
        const request = await Lambda.Post(apiPath, { type: 'fromGreetings', greetingId }, 'lambda');
        return request;
    } catch (err) {
        console.error(err);
        return false;
    }
};
export {
    getActivity,
    getActivities,
    toggleActivityArchivedStatus,
    getRequest,
    getRequests,
    getAcceptedRequests,
    acceptRequest,
    closeRequest,
    unAcceptRequest,
    toggleRequestArchivedStatus,
    getArchivedActivities,
    getArchivedRequests,
    respondToGreeting,
    convertGreetingToRequest,
    convertGreetingToActivity,
};
